// free-shipping-badge.js
// Dodaje attribut data-free-shipping="true" do kart produktów z ceną >= 200 zł.
// Badge wyświetla CSS na podstawie tego attributu.

(function () {
  'use strict';

  const FREE_SHIPPING_THRESHOLD = 200; // PLN

  function parsePrice(text) {
    if (!text) return 0;
    // "640,00 zł" -> 640.00
    // "1 234,56 zł" -> 1234.56
    const cleaned = text
      .replace(/[^\d,.\s]/g, '')
      .replace(/\s/g, '')
      .replace(/\.(?=\d{3})/g, '')  // tysiące z kropką (rzadko w PL)
      .replace(',', '.');
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }

  function applyBadges() {
    const cards = document.querySelectorAll('.product-item__wrapper');
    cards.forEach(card => {
      if (card.dataset.freeShippingChecked) return;
      const priceEl = card.querySelector('.product-item__price .price-regular, .product-item__price .price, .product-item__price');
      if (!priceEl) return;
      const priceText = priceEl.textContent.trim();
      const price = parsePrice(priceText);
      if (price >= FREE_SHIPPING_THRESHOLD) {
        card.setAttribute('data-free-shipping', 'true');
      }
      card.dataset.freeShippingChecked = '1';
    });
  }

  function init() {
    applyBadges();
    const target = document.querySelector('#product-grid') || document.body;
    const observer = new MutationObserver(() => { applyBadges(); });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// =========================================================
// card-image-switcher (dopisane)
// Hover po zdjeciu na kafelku siatki przelacza kolejne zdjecia produktu.
// Zdjecia dociagane leniwie z /products/{handle}.js (bez zmian w liquid).
// Kropki na dole zdjecia pokazuja ktore zdjecie jest aktywne.
// =========================================================
(function () {
  'use strict';

  let ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  const MAX_IMAGES = 6;

  function sized(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function getHandle(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function buildDots(inner, count) {
    const dots = document.createElement('div');
    dots.className = 'card-gallery-dots';
    for (let i = 0; i < count; i++) {
      const s = document.createElement('span');
      if (i === 0) s.className = 'active';
      dots.appendChild(s);
    }
    inner.appendChild(dots);
    return dots;
  }

  function setActiveDot(dots, idx) {
    const ch = dots.children;
    for (let i = 0; i < ch.length; i++) {
      ch[i].className = i === idx ? 'active' : '';
    }
  }

  function initCard(wrapper) {
    if (wrapper.dataset.galleryInit) return;
    const inner = wrapper.querySelector('.product-item__inner');
    if (!inner) return;
    const img = inner.querySelector('img.product-image.first-image')
      || inner.querySelector('img.product-image')
      || inner.querySelector('img');
    if (!img) return;
    wrapper.dataset.galleryInit = '1';

    const state = { images: null, dots: null, current: 0, orig: null, origSet: null, loading: false };

    function ensureImages(cb) {
      if (state.images) { cb(state.images); return; }
      if (state.loading) return;
      const handle = getHandle(wrapper);
      if (!handle) { state.images = []; cb([]); return; }
      state.loading = true;
      fetch(ROOT + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(r => (r.ok ? r.json() : null))
        .then(data => {
          state.images = (data && data.images) ? data.images.slice(0, MAX_IMAGES) : [];
          state.loading = false;
          cb(state.images);
        })
        .catch(() => { state.images = []; state.loading = false; cb([]); });
    }

    function activate(imgs) {
      if (!imgs || imgs.length < 2 || state.dots) return;
      state.orig = img.getAttribute('src');
      state.origSet = img.getAttribute('srcset');
      state.dots = buildDots(inner, imgs.length);
    }

    function show(idx) {
      if (!state.images || idx === state.current) return;
      if (idx < 0 || idx >= state.images.length) return;
      if (img.getAttribute('srcset')) img.removeAttribute('srcset');
      img.src = sized(state.images[idx], 600);
      state.current = idx;
      if (state.dots) setActiveDot(state.dots, idx);
    }

    function reset() {
      if (!state.dots) return;
      if (state.origSet) img.setAttribute('srcset', state.origSet);
      if (state.orig) img.src = state.orig;
      state.current = 0;
      setActiveDot(state.dots, 0);
    }

    inner.addEventListener('mouseenter', function () {
      ensureImages(activate);
    });

    inner.addEventListener('mousemove', function (e) {
      if (!state.images || state.images.length < 2) return;
      const rect = inner.getBoundingClientRect();
      if (!rect.width) return;
      let idx = Math.floor(((e.clientX - rect.left) / rect.width) * state.images.length);
      if (idx < 0) idx = 0;
      if (idx >= state.images.length) idx = state.images.length - 1;
      show(idx);
    });

    inner.addEventListener('mouseleave', reset);
  }

  function scan(root) {
    (root || document).querySelectorAll('.product-item__wrapper.product-grid').forEach(initCard);
  }

  function init() {
    scan(document);
    const grid = document.querySelector('#product-grid') || document.body;
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes && m.addedNodes.forEach(n => {
          if (n.nodeType === 1) {
            if (n.matches && n.matches('.product-item__wrapper.product-grid')) initCard(n);
            scan(n);
          }
        });
      });
    });
    obs.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
